import { frontendURL } from '../../../helper/URLHelper';
import FinanceiroIndex from './pages/FinanceiroIndex.vue';
import {
  LAIS_FINANCEIRO_PERMISSIONS,
  laisCanonicalRedirect,
} from '../laisRouteHelpers';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/financeiro/comissoes'),
    alias: [
      frontendURL('accounts/:accountId/comissoes'),
      frontendURL('accounts/:accountId/commissions'),
    ],
    name: 'financeiro_comissoes_index',
    meta: { permissions: LAIS_FINANCEIRO_PERMISSIONS },
    redirect: laisCanonicalRedirect('financeiro_index', {
      query: { tab: 'comissoes' },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/financeiro'),
    alias: [
      frontendURL('accounts/:accountId/finance'),
      frontendURL('accounts/:accountId/billing'),
      frontendURL('accounts/:accountId/faturamento'),
    ],
    name: 'financeiro_index',
    component: FinanceiroIndex,
    meta: { permissions: LAIS_FINANCEIRO_PERMISSIONS },
  },
];
